<template>
  <v-container class="pa-0 ma-0 color-new-light-grey" fluid>
    <v-container fluid class="pa-0">
      <v-container :class="{'pa-0': this.$vuetify.breakpoint.mdAndUp, 'color-new-light-grey': this.$vuetify.breakpoint.smAndDown}">
        <v-row v-if="this.$vuetify.breakpoint.mdAndUp">
          <v-col class="text-center">
            <h1 class="mb-0 mt-3 text-h1">{{ $t('fp-text-1') }}</h1>
          </v-col>
        </v-row>
        <user-info></user-info>
        <debt-summary v-if="!hasOneDebt"></debt-summary>
      </v-container>
    </v-container>
    <single-debt :orderNr="singleDebtNr" v-if="hasOneDebt"></single-debt>
    <multi-debt v-else></multi-debt>
  </v-container>
</template>

<script>
  import Debt from '@/components/Debt/Debt'
  import MultiDebt from '@/components/MultiDebt/MultiDebt.vue'
  import UserInfo from './UserInfo.vue'
  import DebtSummary from './DebtSummary.vue'

  export default {
    computed: {
      hasOneDebt () {
        return this.$store.getters.hasOnlyOneDebt
      },
      singleDebtNr () {
        return this.$store.getters.singleDebtNr
      }
    },
    components: {
      'single-debt': Debt,
      'multi-debt': MultiDebt,
      'user-info': UserInfo,
      'debt-summary': DebtSummary
    }
  }
</script>

<i18n>
  {
  "fi": {
  "fp-text-1": "Tervetuloa Oma B2 Impact -palveluun"
  },
  "se": {
  "fp-text-1": "Välkommen till Min B2 Impact -webbtjänsten!"
  },
  "en": {
  "fp-text-1": "Welcome to My B2 Impact service"
  }
  }
</i18n>
